import { Route } from 'react-router-dom';
import OverviewDashboard from '../../screens/admin/OverviewDashboard';
import AdminDashboard from '../../screens/admin/AdminDashboard';
import DetailedFarmerView from '../../screens/admin/DetailedFarmerView';
import ResetPasswordUsers from '../../screens/admin/ResetPasswordUsers';
import FarmMapSummary from '../../screens/admin/FarmsMapSummary';
import Announcement from '../../components/Admin/Announcement';

export const adminRoutes = [
  <Route key="admin-home" path="/" element={<OverviewDashboard />} />,
  <Route
    key="admin-farmers"
    path="/admin/farmers"
    element={<AdminDashboard />}
  />,
  <Route
    key="admin-farmer-details"
    path="/farmer-details/:farmerId"
    element={<DetailedFarmerView />}
  />,
  <Route
    key="admin-reset-password"
    path="/reset-password-users"
    element={<ResetPasswordUsers />}
  />,
  <Route
    key="admin-farms-overview"
    path="/admin/farms-overview"
    element={<FarmMapSummary />}
  />,
  <Route
    key="admin-announcement"
    path="/admin/announcement"
    element={<Announcement />}
  />,
];
